import { ISelectOption } from '../base';

export function getSingleSelectOption<T = string | boolean>(
    value: ISelectOption<T> | ISelectOption<T>[] | null | undefined,
): ISelectOption<T> | null {
    if (!value) {
        return null;
    }

    return Array.isArray(value) ? value[0] ?? null : value;
}
